import { mdiApple } from '@mdi/js'
import Icon from '@mdi/react'
import { checkIfIsAppleDevice } from 'Lib'
import { images } from 'images'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Button = styled.button`
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: ${({ theme }) => theme.spacing.xsmall};
  max-width: 50%;
  display: flex;
  flex: 1;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  cursor: pointer;
  justify-content: center;
  color: #000;
  font-family: Fira Sans,sans-serif;
  padding: ${({ theme }) => theme.spacing.xsmall};

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`

export const SocialLoginWrapper = styled.div`
  display: flex;
  max-width: 400px;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.medium};
  margin: ${({ theme }) => theme.spacing.large + ' 0'};
`

interface SocialLoginProps {
  onGooglePress: () => void
  onApplePress: () => void
  /** Set while another sign-in is already running, so a second popup cannot be opened. */
  disabled?: boolean
}

const SocialLogin: React.FC<SocialLoginProps> = ({ onGooglePress, onApplePress, disabled }) => {
  const isAppleDevice = checkIfIsAppleDevice()
  const { t } = useTranslation()

  return (
    <SocialLoginWrapper>
      <Button type='button' onClick={onGooglePress} disabled={disabled}>
        <img width={25} src={images.googleLogo} alt={t('altTexts.googleLogo') || ''} />
      </Button>
      {isAppleDevice && (
        <Button type='button' onClick={onApplePress} disabled={disabled}>
          <Icon path={mdiApple} size={1.5} title={t('altTexts.appleLogo')}/>
        </Button>
      )}
    </SocialLoginWrapper>
  )
}

export default SocialLogin
